<template>
	
	<header class="page-header" :style="{ 'background': 'url(' + uploads + movieDetails.banner + ')' }">
		<div class="container">
			<h1>{{ movieDetails.title }}</h1>


		</div>
	</header>
</template>

<script>
import { UPLOADS } from '@/conf';
export default {
	props: {
		movieDetails: Object,
	},
	data() {
		return {
			imgPath: process.env.BASE_URL,
			uploads:UPLOADS

		}
	}
}
</script>